<template>
 <div class="c-student">
  <div class="c-student__head">
    <i class="head-icon"/>
    <p class="head-title">学生练习效果分布</p>
  </div>

  <div class="c-student__spread" v-if="spreadData.length">
    <div class="spread-left">
      <el-table
      ref="singleTable"
      :data="spreadData"
      :header-cell-style="{background:'#F0F2F5',color:'#909399'}"
      highlight-current-row
      @cell-mouse-enter="enter"
      @cell-mouse-leave="leave"
      style="width: 100%">
        <el-table-column
          prop="level"
          label="正答率分布(人数)"
          align="center">
        </el-table-column>
      </el-table>
    </div>
    <div class="spread-right">
      <div class="spread-right__header">
        学生（正答率）
      </div>
      <div class="spread-right__content" v-if="stuTotalList.length">
        <div class="content-item" v-for="(child, index) in stuTotalList"
        :key="`stu_${index}`" @click="queryStudentReport(child)">
          <span v-if="type===1">
            {{child.student_name}}：{{(child.avg_right_rate*100).toFixed(0)}}%</span>
          <p v-else>{{child.student_name}}：{{(child.avg_right_rate*100).toFixed(0)}}%</p>
        </div>
      </div>
      <div class="student-empty" v-if="!stuTotalList.length">
        <img src="../../images/empty.png" alt="">
        <p class="empty-text">暂无数据</p>
      </div>
    </div>
    <div class="spread-echart">
      <div ref="echart" class="spread-echart__distribute"></div>
      <div class="chart-legend">
        <span
          class="fx"
          v-for="(item, index) in legendList"
          :key="index">
          <span :style="{'background-color': item.color}" class="chart-legend__dot"></span>
          <span>{{item.name}}</span>
        </span>
      </div>
    </div>
  </div>
  <div class="c-student__spread" v-else>
    <el-table
    ref="singleTable"
    :data="spreadData"
    :header-cell-style="{background:'#F0F2F5',color:'#909399'}"
    style="width: 100%">
      <div slot="empty" class="no-data">
        <emptyContent/>
      </div>
      <el-table-column
        prop="level"
        label="完成情况"
        align="center"
        width="200px">
      </el-table-column>
        <el-table-column
        prop="stu_list"
        label="学生（正答率）"
        align="center">
      </el-table-column>
    </el-table>
  </div>

 </div>
</template>

<script>
// import { number } from 'echarts';
// import { getStudentScoreList } from '../../../api/pt';
import emptyContent from '../../components/empty-content.vue';
import { openTab, isScienceArr } from '@/utils';

export default {
  name: 'PracticeStudentMt',
  components: {
    emptyContent,
  },
  props: {
    maxLength: {
      type: Number,
      default: () => 0,
    },
    studentData: {
      type: Array,
      default: () => [],
    },
    spreadData: {
      type: Array,
      default: () => [],
    },
    changeData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      stuTotalList: [],
      studentList: [],
      timer: null,
      echartsColor: '',
      changeColumn: {},
      legendList: [{
        name: '优秀',
        color: '#67C23A',
      }, {
        name: '良好',
        color: '#1989FA',
      }, {
        name: '合格',
        color: '#F4C707',
      }, {
        name: '待关注',
        color: '#F56C6C',
      }],
    };
  },
  watch: {
    changeData(v) {
      this.changeColumn = v;
    },
    studentData(v) {
      this.studentList = v;
    },
    spreadData(v) {
      if (v.length) {
        this.$nextTick(() => {
          this.$refs.singleTable.setCurrentRow(v[0]);
          this.stuTotalList = v[0].stu_list.sort((a, b) => (b.avg_right_rate * 100)
           - (a.avg_right_rate * 100));
          this.type = v[0].type;
          this.initCharts();
        });
      }
    },
  },
  computed: {
    arrList() {
      const arr = [];
      this.spreadData.forEach((item) => {
        const value = item.total === 0 ? 0 : item.stu_list.length / item.total;
        if (item.id === 1) {
          this.echartsColor = '#67C23A';
        } else if (item.id === 2) {
          this.echartsColor = '#1989FA';
        } else if (item.id === 3) {
          this.echartsColor = '#F4C707';
        } else if (item.id === 4) {
          this.echartsColor = '#F56C6C';
        }
        arr.push({
          value: `${Math.floor(value * 100)}`,
          name: item.level.substr(0, 3),
          itemStyle: {
            normal: {
              color: this.echartsColor,
            },
          },
        });
      });
      return arr.filter((item) => Number(item.value) !== 0);
    },
  },
  methods: {
    initCharts() {
      // 基于准备好的dom，初始化echarts实例
      console.log(this.spreadData.map(
        (item) => (item.total === 0 ? 0 : item.stu_list.length / item.total),
      ));
      const myChart = this.$echarts.init(this.$refs.echart);
      // 绘制图表
      myChart.setOption({
        series: [
          {
            type: 'pie',
            radius: ['30%', '60%'],
            data: this.arrList,
            label: {
              normal: {
                show: true,
                formatter(params) {
                  // 自定义颜色
                  const res = `${params.data.value}%`;
                  return res;
                },
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      });
    },
    // hover离开后定位到离开hover的位置
    leave(row) {
      this.spreadData.forEach((item) => {
        if (item.level === row.level) {
          this.$refs.singleTable.setCurrentRow(item);
          this.stuTotalList = item.stu_list.sort((a, b) => (b.avg_right_rate * 100)
           - (a.avg_right_rate * 100));
          this.type = item.type;
        }
      });
    },
    // hover触发处理
    enter(row) {
      this.$refs.singleTable.setCurrentRow({});
      this.spreadData.forEach((item) => {
        if (item.level === row.level) {
          this.stuTotalList = item.stu_list.sort((a, b) => (b.avg_right_rate * 100)
           - (a.avg_right_rate * 100));
          this.type = item.type;
        }
      });
    },
    onSearchClick() {
      // change后的值处理
      if (Object.keys(this.changeColumn).length) {
        this.getStudentScoreList(this.searchName, this.changeColumn);
        return;
      }
      this.getStudentScoreList(this.searchName, {});
    },
    // 正答率样式添加
    getRightClass(value) {
      if (value === -1) {
        return 'default';
      }
      if (value >= 70) {
        return 'level2';
      }
      if (value >= 40) {
        return 'level1';
      }
      return 'level3';
    },
    queryStudentReport(item) {
      if (this.type !== 1) return;
      let params = '';
      let route = '';
      if (Number(this.$route.query.fromType) === 3) { // mt
        route = isScienceArr(this.$route.query.subjectId) ? '/mt-web/transition' : '/artsSelf/transition'; // 文理科
        params = `userId=${item.user_id}&hwId=${this.spreadData[0].evaluate_id}&realname=${item.student_name}`;
      } else if (Number(this.$route.query.fromType) === 4) {
        route = '/amt-web/task';
        params = `userId=${item.user_id}&courseId=${item.course_id}&topicId=${
          item.topic_id}&sectionId=${item.section_id}&subjectId=${
          item.subject_id}&basename=${item.base_name}&sModule=0&noCache=0&realname=${item.student_name}`;
      }
      const isProduction = !window.location.host.includes('dev');
      // 区分线上和测试环境
      const address = isProduction
        ? 'http://jzjx.classba.cn'
        : 'http://jzjx.test.classba.cn'; // 测试环境
      if (params) {
        // 跳到报告页需要item.ts_id参数
        const url = `${address}${route}?${params}`;
        openTab(url);
      }
    },
  },

};
</script>

<style lang="scss" scoped>
.c-student{
  box-sizing: border-box;
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding-top:50px;
  &__spread{
    display: flex;
    padding:20px;
    .spread-left{
      width:28%;
      /deep/.el-table__row{
        height: 94px;
      }
    }
    .spread-right{
      // width:40%;
      flex: 1;
      min-height:286px;
      border:1px solid #F0F2F5;
      // background:#f5f7fa;
      &__header{
        height:47px;
        text-align:center;
        line-height:47px;
        background:#F0F2F5;
        color:rgb(144, 147, 153);
        font-weight: 600;
        font-size:14px;
        font-family: Arial, Helvetica, sans-serif;
      }
      &__content{
        font-size:14px;
        min-height:239px;
        color:#606266;
        overflow:auto;
        font-family: Arial, Helvetica, sans-serif;
        clear:both;
        .content-item{
          width: 25%;
          height: 47px;
          line-height: 47px;
          text-align: center;
          float: left;
          span{
            cursor: pointer;
            color: #1989fa;
          }
        }
      }
    }
    .spread-echart {
      width: 400px;
      height: 400px;
      margin-left: 80px;
      align-self: center;
      // background: linear-gradient(270deg,
      // rgba(160, 173, 255, 0.23) 0%, rgba(51, 183, 255, 0.13) 100%);
      .spread-echart__distribute{
        width: 400px;
        height: 400px;
      }
    }
  }
  &__head{
    padding-left:19px;
    position: relative;
    .head-icon{
      display: block;
      background:url('~@/views/pt/images/class_bg.png');
      background-size:cover;
      width:38px;
      height:29px;
    }
    .head-title{
      position: absolute;
      top:5px;
      left:34px;
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
    }
    .head-operate{
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding:25px;
      .el-button {
        border-radius: 0 4px 4px 0;
      }
      .el-input {
        width: 243px;
        vertical-align: bottom;
        /deep/ .el-input__inner {
          border-radius: 4px 0 0 4px;
        }
      }
    }
  }
  &__table{
    padding:0 20px;
    .disable-color{
      color:#909399
    }
  }
}

/deep/ .el-table__body tr.current-row>td {
  background-color: #fff;
}
/deep/ .el-table td.is-center {
  background-color: #F0F2F5;
}
/deep/.el-table--enable-row-hover .el-table__body tr:hover>td{
    background-color: #fff;
    color: #1989FA;
}
.no-data{
  line-height: 1.8;
  padding: 30px 0;
}
.chart-legend {
  display: flex;
  &__dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-right: 5px;
    border-radius: 50%;
  }
}
.fx {
  flex: 1;
}
 .student-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #C0C4CC;
    font-size: 16px;
    img {
      width: 200px;
      margin-top: 35px;
    }
    .empty-text {
      color: rgba(0,0,0,0.6);
    }
  }
</style>
